export default {
  METRIC: 'metric',
  IMPERIAL: 'imperial',
};
